<template>
    <b-modal v-model="show" :title="$t('settings.efunctionTypesYim')" :no-close-on-esc="true"
             :no-close-on-backdrop="true" size="xl">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4></h4>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-lg-4">
                                    <div class="form-group">
                                        <label>Вилоятни танланг</label>
                                        <v-select
                                                label="label"
                                                v-model="dictionaryData.province"
                                                :filterable="false"
                                                :options="provinces"
                                                @change="onChangeProvince">
                                            <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-12 mt-4">
                                    <div class="table-wrapper">
                                      <table class="customers">
                                          <thead>
                                          <tr>
                                              <th rowspan="2">Фаолия тури</th>
                                              <th colspan="2">
                                                  <span v-if="dictionaryData.province" style="color:black">{{dictionaryData.province.label}} (коффицентлар)</span>
                                                  <span v-if="!dictionaryData.province">Вилоят Номи</span>
                                              </th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for=" item  in dictionaryData.data.provincesBuildingTypes" :key="item.id">
                                              <td>{{item.name}}</td>
                                              <td>
                                                  <numeric-input type="number" lass="form-control" :defaultValue="true" align="left"
                                                                 v-model="item.value"
                                                                 :allowNegative="true" :precision="2" :maxlength="4"
                                                  ></numeric-input>
                                              </td>

                                          </tr>
                                          </tbody>
                                      </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                <div class="col-12 btns-box">
                                    <button class="all-btn delete-btn" v-if="hasPermission('SETTINGS_BUILDING_FUNCTION_TYPES_YIM_ADD')" @click="cancel">{{$t("action.cancel")}}</button>
                                    <button class="all-btn add-btn" @click="save">{{$t("action.save")}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>
<script>
    import initFilterModel from '@/shared/filter';
    import {numericTypes} from '@/shared/constants/mask';
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    import {clone} from '@/shared/utils';
    import AdvancedFilter from '@/shared/filters/advancedFilter';

    export default {
        name: "FunctionTypesYimAddView",
        components: {
            'b-modal': bModal,
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                numericTypes: numericTypes,
                filter: initFilterModel(),
                filterBuildingType: new AdvancedFilter(),
                provinces: [],
                dictionaryData: {
                    dictionaryType: 'FUNCTION_TYPES_FOR_YIM',
                    data: {
                        provincesBuildingTypes: {},
                        provinceId: null,
                    },

                },
            }
        },
        methods: {

            init() {
                const vm = this;

                this.filterBuildingType.onlyParentLookUp = true
                const promises = [this.$http.post('building-type/list', this.filterBuildingType)];

                promises.push(this.$http.get('province/init'));

                Promise.all(promises).then(function (values) {
                    const initData0 = values[0].data;
                    vm.buildingTypes = initData0.data;
                    const initData1 = values[1].data;
                    vm.provinces = initData1.provinces;
                    vm.provinces = initData1.provinces.map((item) => {
                        item.label = item.name;
                        return item;
                    });


                });
            },

            onChangeProvince() {
                let province = this.dictionaryData.province;
                this.dictionaryData.data.provincesBuildingTypes = this.buildingTypes.map(item => ({
                    id: item.id,
                    code: item.code,
                    name: item.name,
                    provinceName: province.name,
                    provinceId: province.id,
                    value: 0,
                }));
                this.dictionaryData.data.provinceId = province.id;
            },

            save() {
                const vm = this;
                this.processing = true;
                this.$http.post('dictionary/save', this.dictionaryData)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('functionTypesYimChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
            ,


            cancel() {
                this.show = false;
            }
        },
        computed: {
            getShortProvinces() {
                return this.provinces.map(province => ({id: province.id, label: province.name}))
            },
        },
        created() {
            this.init();
            this.$eventBus.$on('showFunctionTypesYimAdd', (data) => {
                if (data) {
                    this.dictionaryData.data = clone(data.data);
                }

                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>